export default {
    CADASTRADO: 1,
    CONFIRMADO: 2,
    COM_ATENDIMENTO_AGENDADO: 3,
    PLANTONISTA_AUSENTE: 4
}